<template>
  <div class="bill-detail-with-invoice">
    <el-tabs v-model="activeTab" type="border-card">
      <!-- 原有的账单详情标签 -->
      <el-tab-pane label="账单详情" name="detail">
        <div class="tab-content">
          <!-- 这里放置原有的billDetail内容 -->
          <p>原有的账单详情内容...</p>
        </div>
      </el-tab-pane>

      <!-- 批量上传Invoice标签 -->
      <el-tab-pane name="upload">
        <span slot="label">
          <i class="el-icon-upload"></i> 批量上传Invoice
        </span>
        <InvoiceUpload />
      </el-tab-pane>

      <!-- 整合表校验与下载标签 -->
      <el-tab-pane name="export">
        <span slot="label">
          <i class="el-icon-download"></i> 整合表校验与下载
        </span>
        <IntegratedExport />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import InvoiceUpload from './InvoiceUpload.vue';
import IntegratedExport from './IntegratedExport.vue';

export default {
  name: 'BillDetailWithInvoice',
  components: {
    InvoiceUpload,
    IntegratedExport
  },
  data() {
    return {
      activeTab: 'detail'
    };
  },
  mounted() {
    // 从URL参数获取默认标签
    const tab = this.$route.query.tab;
    if (tab && ['detail', 'upload', 'export'].includes(tab)) {
      this.activeTab = tab;
    }
  },
  watch: {
    activeTab(newTab) {
      // 更新URL参数，但不刷新页面
      this.$router.replace({
        query: { ...this.$route.query, tab: newTab }
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.bill-detail-with-invoice {
  padding: 20px;
}

.tab-content {
  padding: 20px;
  min-height: 400px;
}

/* 自定义标签样式 */
.el-tabs--border-card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
